/**
 * マニフェスト管理
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/suppliers/sales_item_prices/output_reservations`

const getDefaultState = () => {
  return {}
}

const master_supplier_sales_item_price_output_reservation = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {
    /**
     * CSV出力予約
     * @param commit
     * @param conditions { Object } 検索条件
     * @returns {Promise<unknown>}
     */
    create ({ commit }, { conditions }) {
      const parameters = {
        ...conditions
      }
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, parameters).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '出力履歴よりご確認ください' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}

export default master_supplier_sales_item_price_output_reservation
